import React from "react";

const Notice = () => {
  return (
    <div className="py-[25px] bg-primary text-center">
      <p className="text-white">Notice here</p>
    </div>
  );
};

export default Notice;
